import './editble-table.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { t } from 'react-multi-lang';
import { AddBox, Delete ,ContentCopy} from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import React, { ReactNode, useEffect, useRef } from 'react';
interface iOptions {
  [key: string]: any;
}

interface iTouched {
  [key: string]: any;
}
export interface EditableTableProps {
  headers: string[] | ReactNode [];
  values: any;
  handleChange: (e: React.ChangeEvent, index: number) => void;
  selectInput?: string[];
  options?: iOptions;
  addLine?: Function;
  removeLine?: Function;
  handleBlur?: Function;
  error: any;
  touched: iTouched;
  array_name?: string;
  has_general_options?: boolean;
  lines_number: number;
  number_inputs?: undefined | string[];
  maxHeight?: string;
  copyLine?:(line_number:string)=>void,
  spans?:{[key:string]:number},
  units?:{[key:string]:string},
  no_actions?:boolean
}
const EditbleTable = ({
  headers,
  values,
  handleChange,
  selectInput,
  options,
  addLine,
  removeLine,
  touched,
  error,
  array_name,
  has_general_options,
  lines_number,
  number_inputs,
  maxHeight,
  handleBlur,
  copyLine,
  spans,
  units,
  no_actions

}: EditableTableProps) => {
  const tabel = useRef(null);

  useEffect(() => {
    if (tabel.current) {
      (tabel.current as HTMLDivElement).scroll({
        behavior: 'smooth',
        top: (tabel.current as HTMLDivElement).children[0].scrollHeight,
      });
    }
  }, []);
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault(); // Prevent the default Tab behavior

      // Invert the focus direction
      const focusableElements = document.querySelectorAll('.table_input');
      const focusableArray = Array.from(focusableElements);

      const currentIndex = focusableArray.indexOf(document.activeElement!!);
      const nextIndex =
        currentIndex === 0 ? focusableArray.length - 1 : currentIndex - 1;
      (focusableArray[nextIndex] as HTMLInputElement).focus();
    }
  };
  //console.log('Editable Table values',values)

  return (
    <Grid container size={12}>
      <Grid  container size={12}>
        <TableContainer
          component={Paper}
          className="editbleTable"
          ref={tabel as any}
          style={{ paddingTop: '0', maxHeight }}>
          <Table sx={{ minWidth: 650 }} stickyHeader={true}>
            <TableHead>
              <TableRow >
               {!no_actions && <TableCell></TableCell>}
                {headers.map((ele: string | ReactNode, index: number) => (
                  <TableCell align="right" key={`${ele}${index}`}
                  colSpan={spans&& typeof(ele)==='string'&& spans[ele]?spans[ele]:1}
                  >
                    
                    {typeof(ele)=== 'string'?
                    ele + `${units&& typeof(ele)==="string" && units[ele]? ` ${units[ele]} ` : ''}`:
                    ele}
                    
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody style={{ position: 'relative' }}>
              {Object.keys(values).map((i, index) => (
                <TableRow
                  key={i}
                  style={{
                  
                    width: '100%',
                  }}
                  sx={{
                    '.MuiTableCell-root':{
                     
                    }
                  }}
                  >
                  {
                  (array_name && array_name !== 'dummy'
                    ? values.length > 0
                    : Object.keys(values).length > 0) ? (
                    <TableCell style={{whiteSpace:'nowrap'}} 
                   colSpan={1}
                    >
                     { removeLine &&
                      <IconButton onClick={() => removeLine(i)}
                      sx={{
                        padding:'0px',
                        transition:'all 1s ease',
                        '&:hover':{
                          transform:'scale(1);',
                          background:'lightgray'
                          
                        }
                      }}
                       >
                        <Delete color="error" />
                      </IconButton>}
                      {copyLine &&
                          <IconButton onClick={() => copyLine(i)}
                          sx={{
                            padding:'0px',
                            transition:'all 1s ease',
                            '&:hover':{
                              transform:'scale(1);',
                              background:'lightgray'
                              
                            }
                          }}
                          >
                            <ContentCopy color='primary'/>
                          </IconButton>
                      }
                    </TableCell>
                  ) : (
                    <TableCell colSpan={1}></TableCell>
                  )}
                  
                  {Object.keys(values[i]).map((elem: string, index: number) => {
                    if (selectInput?.includes(elem)) {
                      return (
                        <TableCell
                          key={index}
                          colSpan={2}
                         
                          sx={{
                            borderColor: 'lightgray',
                            borderLeft: '1px solid lightgray',
                            borderLeftStyle: 'groove',
                            border: !array_name
                              ? Boolean(error[elem]) && touched[i]
                                ? '1px solid red'
                                : ''
                              : error &&
                                error[i] &&
                                Boolean(error[i][elem]) &&
                                touched[array_name]
                              ? '1px solid red'
                              : '',
                          }}>
                          <select
                          style={{minWidth:'150px'}}
                            value={values && values[i] ? 
                               number_inputs?.includes(elem)?
                               parseInt(values[i][elem]):
                              values[i][elem] : ''}
                            className={`select ${
                              !array_name
                                ? Boolean(error[elem]) && touched[i]
                                  ? 'invalid'
                                  : ''
                                : error &&
                                  error[i] &&
                                  Boolean(error[i][elem]) &&
                                  touched[array_name]
                                ? 'invalid'
                                : ''
                            }`}
                            name={
                              array_name
                                ? `${array_name}[${i}][${elem}]`
                                : `[${i}][${elem}]`
                            }
                            onChange={(e: React.ChangeEvent) => {
                              handleChange(e, parseInt(i));
                            }}>
                            <>
                              <option value="">{t('select...')}</option>
                              {options && options[elem]
                                ? !has_general_options
                                  ? options[elem].map((ele: any, j: number) => {
                                      return (
                                        <option
                                          value={ele.value ? ele.value : ''}
                                          key={'options[elem]' + j}>
                                          {ele.name ? ele.name : ''}
                                        </option>
                                      );
                                    })
                                  : options[elem] && options[elem][i]
                                  ? options[elem][i].map(
                                      (ele: any, j: number) => {
                                        return (
                                          <option
                                            value={ele.value ? ele.value : ''}
                                            key={'options[elem][i]' + j}>
                                            {ele.name ? ele.name : ''}
                                          </option>
                                        );
                                      },
                                    )
                                  : options[elem]['general'] &&
                                    options[elem]['general'].length > 0
                                  ? options[elem]['general'].map(
                                      (ele: any, j: number) => {
                                        return (
                                          <option
                                            value={ele.value ? ele.value : ''}
                                            key={'options[elem][general' + j}>
                                            {ele.name ? ele.name : ''}
                                          </option>
                                        );
                                      },
                                    )
                                  : ''
                                : ''}
                            </>
                          </select>
                        </TableCell>
                      );
                    }
                    
                    return (
                      <TableCell
                        colSpan={1}
                        key={elem + `${index}`}
                        sx={{
                          borderColor: 'lightgray',
                          borderLeft: '1px solid  lightgray',
                          borderLeftStyle: 'groove',
                          padding: '16px 5px',
                          border: !array_name
                            ? Boolean(error[`[${elem}]`]) && touched[i][elem]
                              ? '1px solid red'
                              : ''
                            : error &&
                              error[i] &&
                              Boolean(error[i][elem]) &&
                             (array_name !== 'dummy'? touched[array_name]:touched[i][elem])
                            ? '1px solid red'
                            : '',
                        }}>
                        <input
                          type={
                            number_inputs
                              ? number_inputs.filter((number_input) =>
                                  array_name && array_name !== 'dummy'
                                    ? `${array_name}[${i}][${elem}]`.includes(
                                        number_input,
                                      )
                                    : `[${i}][${elem}]`.includes(number_input),
                                ).length > 0
                                ? 'number'
                                : 'text'
                              : 'text'
                          }
                          onKeyDown={handleKeyDown}
                          className={`input  table_input ${
                            !array_name
                              ? Boolean(error[`[${elem}]`]) && touched[i]
                                ? 'ivalid'
                                : ''
                              : error &&
                                error[i] &&
                                Boolean(error[i][elem]) &&
                               (array_name !== 'dummy'? touched[array_name]:touched[i][elem])
                              ? 'invalid'
                              : ''
                          }`}
                          name={
                            array_name && array_name !== 'dummy'
                              ? `${array_name}[${i}][${elem}]`
                              : `[${i}][${elem}]`
                          }
                          key={index}
                          onBlur={handleBlur?handleBlur as any :undefined}
                          contentEditable={true}
                          onChange={(e: React.ChangeEvent) =>
                            handleChange(e, parseInt(i))
                          }
                          value={values && values[i] ? values[i][elem] : ''}
                        />
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid
        
        container
        size={12}
        style={{ position: 'relative' }}
        className="tableAction">
        {addLine && (
          <IconButton className="addIcon" onClick={() => addLine()}>
            <AddBox />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

export default EditbleTable;
